// extracted by mini-css-extract-plugin
module.exports = {"container":"register_container__2rH3-","wrapper":"register_wrapper__29oUW"};